import React, { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useServiceData } from '../../hooks/useServiceData'
import { useSubServiceData } from '../../hooks/useSubServiceData'
import './StageBlock.css'

const StageCard = ({ item }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <article className="stage-block__card">
      <div className="stage-block__image-wrap">
        <div
          className={`stage-block__image-skeleton img-skeleton ${isLoaded ? 'is-hidden' : ''}`}
          aria-hidden="true"
        />
        <img
          className={`stage-block__image img-fade-in ${isLoaded ? 'is-loaded' : ''}`}
          src={item.image}
          alt={item.title}
          onLoad={() => setIsLoaded(true)}
        />
      </div>
      <div className="stage-block__content">
        <h3 className="stage-block__card-title">
          <span className="stage-block__number">{String(item.stage).padStart(2, '0')}</span>{' '}
          {item.title}
        </h3>
        <p className="stage-block__description">{item.description}</p>
      </div>
    </article>
  )
}

const PLACEHOLDER_STAGE_COUNT = 4

const StageSkeletonCard = () => (
  <article className="stage-block__card" aria-hidden="true">
    <div className="stage-block__image-wrap">
      <div className="stage-block__image-skeleton img-skeleton" />
    </div>
    <div className="stage-block__content">
      <div className="stage-block__card-title--skeleton img-skeleton" />
      <div className="stage-block__description--skeleton img-skeleton" />
      <div className="stage-block__description--skeleton img-skeleton" />
    </div>
  </article>
)

const StageBlock = () => {
  const { slug, subSlug } = useParams()

  const { data: service, isLoading: serviceLoading } = useServiceData(slug)
  const { data: subService, isLoading: subServiceLoading } = useSubServiceData(subSlug ? slug : null, subSlug)
  const isLoading = subSlug ? subServiceLoading : serviceLoading

  const stages = useMemo(() => {
    const raw = subSlug ? subService?.stages : service?.stages
    if (!raw || raw.length === 0) return []
    return [...raw]
      .sort((a, b) => a.order - b.order)
      .map((s, i) => ({ ...s, stage: i + 1 }))
  }, [service, subService, subSlug])

  if (isLoading) {
    return (
      <section className="stage-block" aria-label="Этапы работ" aria-busy="true">
        <div className="stage-block__inner">
          <h2 className="stage-block__title">Этапы работ</h2>
          <p className="stage-block__note">Последовательные этапы для стабильного и качественного результата.</p>

          <div className="stage-block__grid">
            {Array.from({ length: PLACEHOLDER_STAGE_COUNT }).map((_, index) => (
              <StageSkeletonCard key={`stage-skeleton-${index}`} />
            ))}
          </div>
        </div>
      </section>
    )
  }

  if (stages.length === 0) return null

  return (
    <section className="stage-block" aria-label="Этапы работ">
      <div className="stage-block__inner">
        <h2 className="stage-block__title">Этапы работ</h2>
        <p className="stage-block__note">Последовательные этапы для стабильного и качественного результата.</p>

        <div className="stage-block__grid">
          {stages.map((item) => (
            <StageCard item={item} key={`${item.stage}-${item.title}`} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default StageBlock
